import { useQuery } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getLevyReport = async ({
  month,
  year,
  companyCode,
  locationCode,
  employeeCode = 0,
  isAllCompanies = false,
  selectedCompanyCode = "",
  userId = 0,
}) => {
  const url = isAllCompanies
    ? Api_EndPoints.AllCompanies_GetEmployeesLevyReport
    : Api_EndPoints.GetEmployeesLevyReport;
  let queryString =
    employeeCode !== 0
      ? `Month=${month}&Year=${year}&CompanyCode=${isAllCompanies ? selectedCompanyCode : companyCode}&LocationCode=${locationCode}&EmployeeCode=${employeeCode}`
      : `Month=${month}&Year=${year}&CompanyCode=${isAllCompanies ? selectedCompanyCode : companyCode}&LocationCode=${locationCode}`;
  if (isAllCompanies && userId !== 0) {
    queryString += `&UserId=${userId}`;
  }
  const { data } = await http_payroll.get(`${url}?${queryString}`);
  return data;
};

export const useGetLevyReportQuery = (input) => {
  const isAllCompanies = Boolean(input?.isAllCompanies);
  return useQuery({
    queryKey: [
      isAllCompanies
        ? Api_EndPoints.AllCompanies_GetEmployeesLevyReport
        : Api_EndPoints.GetEmployeesLevyReport,
    ],
    queryFn: () => getLevyReport(input),
    refetchOnWindowFocus: false,
  });
};
